import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from './loader.component';


/**
 * This service handles the component that indicates the loading state of another component or page.
 */
@Injectable({ providedIn: 'root' })
export class LoaderService {

	private readonly modalSrv = inject(NgbModal);

	private _modalRef: NgbModalRef | null = null;


	/**
	 * Show the loader component.
	 * @param ignoreCheck ignore if other modals are opened.
	 */
	show(ignoreCheck = false): void {
		if (ignoreCheck || !this.modalSrv.hasOpenModals()) {
			this._modalRef = this.modalSrv.open(LoaderComponent, { centered: true, backdrop: 'static' });
		}
	}

	/**
	 * Hide the loader component.
	 */
	hide(): void {
		this._modalRef?.close();
	}

}
